<template>
  <v-container class="pa-0 mx-0">
    <Login />  <!-- Include the Login component from components/auth -->
  </v-container>
</template>

<script>
import Login from '@/components/auth/Login.vue'; // Import the Login component

export default {
  components: {
    Login,
  },
};
</script>

<style scoped>
/* You can add styles specific to the login page here */
</style>
